/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberAcquisition {
  amount?: number;
  badge?: string;
  boxId?: string;
  compositionId?: number;
  compositionName?: string;
  couponId?: number;
  couponName?: string;
  couponUsageTypeId?: number;
  cpf?: number;
  dateRenewed?: Date;
  editionId?: number;
  email?: string;
  name?: string;
  phone?: string;
  statusMillennium?: string;
  subscriberEditionName?: string;
  subscriberEditionStatusName?: string;
  subscriberGroupId?: number;
  subscriberId?: number;
  subscriberStatus?: string;
  subscriptionName?: string;
  subscriptionTypeName?: string;
  theme?: string;
}
